import React from 'react';
import { getProfileInitials } from '../../utils/profileDisplay';
import './profileAvatar.css';

export default function ProfileAvatar({
  email,
  displayName = '',
  avatarUrl = '',
  className = '',
  imageClassName = '',
}) {
  const initials = getProfileInitials(email, displayName);
  const classes = `profile-avatar ${className}`.trim();

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt=""
        className={`profile-avatar__image ${imageClassName}`.trim()}
      />
    );
  }

  return <span className={classes}>{initials}</span>;
}
